import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend"
import React, { Component } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { Link } from "react-router-dom"
import Toggle from "react-toggle"
import "react-toggle/style.css"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import MultiCurrencySelect from "../../common/currency/multiselect.component.jsx"
import TimeZoneSelect from "../../common/date/timezoneselect.component.jsx"
import MultiLanguageSelect from "../../common/language/multiselect.component.jsx"
import SideBar from "../../common/layout/sidebar.component.jsx"
import PageSizeSelect from "../../common/proposal/pagesizeselect.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import FormattedInputField from "../../sharedComponents/formattedInputField.component.jsx"
import { getOptionValueWithOptionKey } from "../../state/default-option/DefaultOption"
import DefaultOptionService from "../../state/default-option/DefaultOptionService"
import { isError } from "../../state/helpers/Error"
import { SupportedSettings } from "./Settings.jsx"
class AccountDetailsEditForm extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            account: null,
            testMode: false,
            currency: "USD",
            timeZone: "",
            taxNumber: "",
            documentSubDomain: "",
            quotePrefix: "",
            quoteStartFrom: "",
            invoicePrefix: "",
            invoiceStartFrom: "",
            orderPrefix: "",
            orderStartFrom: "",
            defaultLanguage: "en-CA",
            defaultQuoteDepositRatio: 0,
            defaultOrderDepositRatio: 0,
            showShortDescriptionInListing: false,
            showSKUInPricingTable: false,
            autoApplyAvailableCreditMemo: false,
            features: [],
            additionalCurrencies: [],
            additionalLanguages: [],
            pageSize: "letter",
            hideBranding: false,
            isTaxInclusive: false,
            showPriceWarning: false,
            isSubmitting: false
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submitDefaultCurrency = this.submitDefaultCurrency.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu("account")
        AppContext.getApiClient()
            .get("/accounts/account-details")
            .then(result => {
                this.setState({
                    account: result,
                    currency: result.attributes.currency,
                    timeZone: result.attributes.timeZone,
                    testMode: result.attributes.testMode,
                    defaultLanguage: result.attributes.defaultLanguage,
                    additionalCurrencies: result.attributes.additionalCurrencies,
                    additionalLanguages: result.attributes.additionalLanguages,
                    hideBranding: result.attributes.hideBranding,
                    numberOfDaysBeforeQuoteExpiration: result.attributes.numberOfDaysBeforeQuoteExpiration,
                    taxNumber: result.attributes.taxNumber,
                    features: result.attributes.features.map(f => {
                        return {
                            featureKey: f.attributes.featureKey,
                            enabled: f.attributes.enabled
                        }
                    }),
                    pageSize: result.attributes.pageSize || this.state.pageSize,
                    showPriceWarning: result.attributes.showPriceWarning,
                    isTaxInclusive: result.attributes.isTaxInclusive
                })
            })

        DefaultOptionService.RetrieveDefaultProposalOptions().then(res => {
            if (!isError(res)) {
                this.setState({
                    quotePrefix: getOptionValueWithOptionKey(res, "quote-identifier-prefix", "QUO"),
                    quoteStartFrom: getOptionValueWithOptionKey(res, "quote-identifier-start-from", "1"),
                    documentSubDomain: getOptionValueWithOptionKey(res, "quote-sub-domain", ""),
                    defaultQuoteDepositRatio: getOptionValueWithOptionKey(res, "default-quote-deposit", 0) * 100,
                    invoicePrefix: getOptionValueWithOptionKey(res, "invoice-identifier-prefix", "INV"),
                    invoiceStartFrom: getOptionValueWithOptionKey(res, "invoice-identifier-start-from", "1"),
                    orderPrefix: getOptionValueWithOptionKey(res, "order-identifier-prefix", "ORD"),
                    orderStartFrom: getOptionValueWithOptionKey(res, "order-identifier-start-from", "1"),
                    showShortDescriptionInListing: getOptionValueWithOptionKey(res, "show-short-description-in-listing", false),
                    showSKUInPricingTable: getOptionValueWithOptionKey(res, SupportedSettings.ShowSKUInPricingTable, false),
                    autoApplyAvailableCreditMemo: getOptionValueWithOptionKey(res, "auto-apply-available-credit-memo", false),
                    defaultOrderDepositRatio: getOptionValueWithOptionKey(res, "default-order-deposit", 0) * 100
                })
            }
        })
    }

    submitDefaultCurrency(event) {
        this.setState({
            isSubmitting: true
        })
        let updates = {}
        const allowedFormFields = [
            "currency",
            "defaultLanguage",
            "features",
            "testMode",
            "timeZone",
            "hideBranding",
            "additionalCurrencies",
            "additionalLanguages",
            "numberOfDaysBeforeQuoteExpiration",
            "pageSize",
            "taxNumber",
            "isTaxInclusive",
            "showPriceWarning"
        ]
        for (let i = 0; i < allowedFormFields.length; i++) {
            let field = allowedFormFields[i]
            if (this.state[field] !== this.state.account.attributes[field]) {
                updates[field] = this.state[field]
            }
        }
        Promise.all([
            AppContext.getApiClient().patch("/accounts/account-details", updates),
            AppContext.getApiClient().patch("/default-proposal-options/quote-identifier-prefix", {
                value: this.state.quotePrefix
            }),
            AppContext.getApiClient().patch("/default-proposal-options/quote-identifier-start-from", {
                value: this.state.quoteStartFrom
            }),
            AppContext.getApiClient().patch("/default-proposal-options/invoice-identifier-prefix", {
                value: this.state.invoicePrefix
            }),
            AppContext.getApiClient().patch("/default-proposal-options/invoice-identifier-start-from", {
                value: this.state.invoiceStartFrom
            }),
            AppContext.getApiClient().patch("/default-proposal-options/order-identifier-prefix", {
                value: this.state.orderPrefix
            }),
            AppContext.getApiClient().patch("/default-proposal-options/order-identifier-start-from", {
                value: this.state.orderStartFrom
            }),
            AppContext.getApiClient().patch("/default-proposal-options/quote-sub-domain", {
                value: this.state.documentSubDomain
            }),
            AppContext.getApiClient().patch("/default-proposal-options/default-quote-deposit", {
                value: this.state.defaultQuoteDepositRatio ? this.state.defaultQuoteDepositRatio / 100 : 0
            }),
            AppContext.getApiClient().patch("/default-proposal-options/show-short-description-in-listing", {
                value: this.state.showShortDescriptionInListing === true
            }),
            AppContext.getApiClient().patch("/default-proposal-options/show-sku-in-pricing-table", {
                value: this.state.showSKUInPricingTable === true
            }),
            AppContext.getApiClient().patch("/default-proposal-options/auto-apply-available-credit-memo", {
                value: this.state.autoApplyAvailableCreditMemo === true
            }),
            AppContext.getApiClient().patch("/default-proposal-options/default-order-deposit", {
                value: this.state.defaultOrderDepositRatio ? this.state.defaultOrderDepositRatio / 100 : 0
            })
        ]).then(results => {
            if (results.filter(r => r.error !== undefined).length === 0) {
                AppContext.setCurrency(this.state.currency)
                AppContext.setAccount(results[0])
                window.location.replace('/settings')
            }
        })
        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value,
            additionalCurrencies: this.state.additionalCurrencies.filter(currency => currency !== value),
            additionalLanguages: this.state.additionalLanguages.filter(lang => lang !== value)
        })
    }

    handleFeatureChange(featureKey) {
        return function (event) {
            if (this.state.features.filter(f => f.featureKey === featureKey).length === 0) {
                this.state.features.push({
                    featureKey: featureKey,
                    enabled: event.target.checked
                })
            }
            this.setState({
                features: this.state.features.map(f => {
                    if (f.featureKey === featureKey) {
                        f.enabled = event.target.checked
                    }
                    return f
                })
            })
        }.bind(this)
    }

    isInvoiceEnabled() {
        return AppContext.getAccount().isFeatureEnabled(Features.Invoice)
    }

    isOrderEnabled() {
        return AppContext.getAccount().isFeatureEnabled(AccountFeatures.FeatureOrder)
    }

    render() {
        if (!this.state.account) {
            return <LoadingSpinner />
        }

        const messages = defineMessages({
            save_btn: {
                id: "settings.account.form.edit.save_btn",
                defaultMessage: "Save"
            }
        })

        const supportedFeatures = []

        if (AppContext.getUserLoggedIn().attributes.superUser) {
            supportedFeatures.push({
                key: Features.WorkOrder,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.work_order_label"
                        defaultMessage="Work order module"
                    />
                )
            })
        }
        if (AppContext.getUserLoggedIn().attributes.superUser) {
            supportedFeatures.push({
                key: Features.Invoice,
                label: <FormattedMessage id="settings.account.form.edit.feature.invoice_label" defaultMessage="Invoice module" />
            })
        }
        if (AppContext.getUserLoggedIn().attributes.superUser) {
            supportedFeatures.push({
                key: Features.Automation,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.automation_label"
                        defaultMessage="Automation module"
                    />
                )
            })
        }

        // Account features
        if (AppContext.getUserLoggedIn().attributes.superUser) {
            supportedFeatures.push({
                key: AccountFeatures.FeatureRemovePaymentButton,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.remove_payment_section_label"
                        defaultMessage="Remove payment section"
                    />
                )
            })
            supportedFeatures.push({
                key: AccountFeatures.FeatureDigitalSignature,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.digital_signature_label"
                        defaultMessage="Digital signature"
                    />
                )
            })
            supportedFeatures.push({
                key: AccountFeatures.FeatureBulkOperations,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.bulk_operations_label"
                        defaultMessage="Bulk operations"
                    />
                )
            })
            supportedFeatures.push({
                key: AccountFeatures.FeatureMultiLocation,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.multi_location_label"
                        defaultMessage="Multi location"
                    />
                )
            })
            supportedFeatures.push({
                key: AccountFeatures.FeatureIncludePdfAttachmentInInvoice,
                label: (
                    <FormattedMessage
                        id="settings.account.form.edit.feature.include_pdf_attachment_invoice"
                        defaultMessage="Include Pdf attachment in invoice"
                    />
                )
            })
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="settings.account.form.edit.title"
                                        defaultMessage="Edit account details"
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={this.submitDefaultCurrency}>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module pt-0">
                            {this.state.testMode && (
                                <div className="form-group row border-bottom mb-3 py-3 bg-light">
                                    <label className="col-2 col-form-label text-align-right" htmlFor="testMode">
                                        <strong>
                                            <FormattedMessage
                                                id="settings.account.form.edit.show_sample_data_label"
                                                defaultMessage="Show sample data"
                                            />
                                        </strong>
                                    </label>
                                    <div className="col-10">
                                        <Toggle
                                            defaultChecked={this.state.testMode}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    testMode: !this.state.testMode
                                                })
                                            }}
                                        />
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="settings.account.form.edit.show_sample_data_description"
                                                defaultMessage="This will show sample data in your account to explore all the feature of QuoteMachine"
                                            />
                                        </small>
                                    </div>
                                </div>
                            )}
                            <div className="form-group row mt-4">
                                <label className="col-2 col-form-label text-align-right" htmlFor="currency">
                                    <FormattedMessage id="settings.account.form.edit.currency_label" defaultMessage="Currency" />
                                </label>
                                <div className="col-10">
                                    <MultiCurrencySelect
                                        value={this.state.currency}
                                        onChange={val => {
                                            this.setState({ currency: val })
                                        }}
                                        clearable={false}
                                        multi={false}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label className="col-2 col-form-label text-align-right" htmlFor="currency">
                                    <FormattedMessage
                                        id="settings.account.form.edit.additional_currencies_label"
                                        defaultMessage="Additional currencies"
                                    />
                                </label>
                                <div className="col-10">
                                    <MultiCurrencySelect
                                        exclude={[this.state.currency]}
                                        value={this.state.additionalCurrencies}
                                        onChange={val => {
                                            this.setState({ additionalCurrencies: val })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="defaultLanguage">
                                    <FormattedMessage id="settings.account.form.edit.language_label" defaultMessage="Language" />
                                </label>
                                <div className="col-10">
                                    <select
                                        name="defaultLanguage"
                                        value={this.state.defaultLanguage ? this.state.defaultLanguage.substring(0, 2) : ""}
                                        onChange={this.handleFormChange}
                                        id="defaultLanguage"
                                        className="form-control"
                                    >
                                        {GlobalHelper.getSupportedLanguages().map(language => {
                                            return (
                                                <option value={language} key={language}>
                                                    {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label className="col-2 col-form-label text-align-right" htmlFor="language">
                                    <FormattedMessage
                                        id="settings.account.form.edit.additional_languages_label"
                                        defaultMessage="Additional languages"
                                    />
                                </label>
                                <div className="col-10">
                                    <MultiLanguageSelect
                                        exclude={[this.state.defaultLanguage.substring(0, 2)]}
                                        value={this.state.additionalLanguages}
                                        onChange={val => {
                                            this.setState({ additionalLanguages: val })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label className="col-2 col-form-label text-align-right" htmlFor="currency">
                                    <FormattedMessage
                                        id="settings.account.form.edit.time_zone_label"
                                        defaultMessage="Time zone"
                                    />
                                </label>
                                <div className="col-10">
                                    <TimeZoneSelect
                                        value={this.state.timeZone}
                                        onChange={zone => {
                                            this.setState({ timeZone: zone })
                                        }}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="taxNumber">
                                    <FormattedMessage
                                        id="settings.account.form.edit.tax_number_label"
                                        defaultMessage="Tax number"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        id={"taxNumber"}
                                        name={"taxNumber"}
                                        value={this.state.taxNumber}
                                        onChange={this.handleFormChange}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label className="col-2 col-form-label text-align-right" htmlFor="pageSize">
                                    <FormattedMessage
                                        id="settings.account.form.edit.page_size_label"
                                        defaultMessage="Paper size"
                                    />
                                </label>
                                <div className="col-10">
                                    <PageSizeSelect
                                        value={this.state.pageSize}
                                        onChange={pageSize => {
                                            this.setState({ pageSize })
                                        }}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="documentSubDomain">
                                    <FormattedMessage
                                        id="settings.account.form.edit.quote_sub_domain_label"
                                        defaultMessage="Quote sub domain"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        id={"documentSubDomain"}
                                        name={"documentSubDomain"}
                                        value={this.state.documentSubDomain}
                                        onChange={this.handleFormChange}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="quotePrefix">
                                    <FormattedMessage
                                        id="settings.account.form.edit.quote_prefix_label"
                                        defaultMessage="Quote prefix"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        id={"quotePrefix"}
                                        name={"quotePrefix"}
                                        value={this.state.quotePrefix}
                                        onChange={this.handleFormChange}
                                        type="text"
                                        className="form-control"
                                        maxLength={3}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="quotePrefix">
                                    <FormattedMessage
                                        id="settings.account.form.edit.quote_start_from_label"
                                        defaultMessage="Initial quote number"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        id={"quoteStartFrom"}
                                        name={"quoteStartFrom"}
                                        value={this.state.quoteStartFrom}
                                        onChange={this.handleFormChange}
                                        type="number"
                                        className="form-control"
                                        maxLength={6}
                                    />
                                </div>
                            </div>
                            {this.isInvoiceEnabled() ? (
                                <div className="form-group row">
                                    <label className="col-2 col-form-label text-align-right" htmlFor="invoicePrefix">
                                        <FormattedMessage
                                            id="settings.account.form.edit.invoice_prefix_label"
                                            defaultMessage="Invoice prefix"
                                        />
                                    </label>
                                    <div className="col-10">
                                        <input
                                            id={"invoicePrefix"}
                                            name={"invoicePrefix"}
                                            value={this.state.invoicePrefix}
                                            onChange={this.handleFormChange}
                                            type="text"
                                            className="form-control"
                                            maxLength={3}
                                        />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {this.isInvoiceEnabled() ? (
                                <div className="form-group row">
                                    <label className="col-2 col-form-label text-align-right" htmlFor="invoiceStartFrom">
                                        <FormattedMessage
                                            id="settings.account.form.edit.invoice_start_from_label"
                                            defaultMessage="Initial invoice number"
                                        />
                                    </label>
                                    <div className="col-10">
                                        <input
                                            id={"invoiceStartFrom"}
                                            name={"invoiceStartFrom"}
                                            value={this.state.invoiceStartFrom}
                                            onChange={this.handleFormChange}
                                            type="number"
                                            className="form-control"
                                            maxLength={6}
                                        />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {this.isOrderEnabled() && (
                                <span>
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label text-align-right" htmlFor="orderPrefix">
                                            <FormattedMessage
                                                id="settings.account.form.edit.order_prefix_label"
                                                defaultMessage="Order prefix"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <input
                                                id={"orderPrefix"}
                                                name={"orderPrefix"}
                                                value={this.state.orderPrefix}
                                                onChange={this.handleFormChange}
                                                type="text"
                                                className="form-control"
                                                maxLength={3}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label text-align-right" htmlFor="orderStartFrom">
                                            <FormattedMessage
                                                id="settings.account.form.edit.order_start_from_label"
                                                defaultMessage="Initial order number"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <input
                                                id={"orderStartFrom"}
                                                name={"orderStartFrom"}
                                                value={this.state.orderStartFrom}
                                                onChange={this.handleFormChange}
                                                type="number"
                                                className="form-control"
                                                maxLength={6}
                                            />
                                        </div>
                                    </div>
                                </span>
                            )}
                            {!GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() && (
                                <>
                                    <div className="form-group row">
                                        <label
                                            className="col-2 col-form-label text-align-right"
                                            htmlFor="defaultQuoteDepositRatio"
                                        >
                                            <FormattedMessage
                                                id="settings.account.form.edit.default_proposal_deposit_label"
                                                defaultMessage="Default quote deposit"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <div className="input-group mb-3">
                                                <FormattedInputField
                                                    id={"defaultQuoteDepositRatio"}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={GlobalHelper.applyLocaleDecimal(
                                                        "0.00",
                                                        AppContext.getLocale().getLanguage()
                                                    )}
                                                    valueType="decimal"
                                                    value={this.state.defaultQuoteDepositRatio}
                                                    onValueChange={newValue => {
                                                        this.setState({ defaultQuoteDepositRatio: newValue })
                                                    }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            className="col-2 col-form-label text-align-right"
                                            htmlFor="defaultOrderDepositRatio"
                                        >
                                            <FormattedMessage
                                                id="settings.account.form.edit.default_proposal_order_deposit_label"
                                                defaultMessage="Default order deposit"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <div className="input-group mb-3">
                                                <FormattedInputField
                                                    id={"defaultOrderDepositRatio"}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={GlobalHelper.applyLocaleDecimal(
                                                        "0.00",
                                                        AppContext.getLocale().getLanguage()
                                                    )}
                                                    valueType="decimal"
                                                    value={this.state.defaultOrderDepositRatio}
                                                    onValueChange={newValue => {
                                                        this.setState({ defaultOrderDepositRatio: newValue })
                                                    }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="form-group row d-flex align-items-center">
                                <label
                                    className="col-2 col-form-label text-align-right"
                                    htmlFor="numberOfDaysBeforeQuoteExpiration"
                                >
                                    <FormattedMessage
                                        id="settings.account.form.edit.expiration_number_of_days_label"
                                        defaultMessage="Number of days before a quote becomes expired after it's proposed"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        id={"numberOfDaysBeforeQuoteExpiration"}
                                        name={"numberOfDaysBeforeQuoteExpiration"}
                                        value={this.state.numberOfDaysBeforeQuoteExpiration}
                                        onChange={this.handleFormChange}
                                        type="number"
                                        className="form-control"
                                        min="1"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="showShortDescriptionInListing">
                                    <FormattedMessage
                                        id="settings.account.form.edit.show_short_description_in_listing_label"
                                        defaultMessage="Show product short description in listing"
                                    />
                                </label>
                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={"showShortDescriptionInListing"}
                                            defaultChecked={this.state.showShortDescriptionInListing}
                                            checked={this.state.showShortDescriptionInListing}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    showShortDescriptionInListing: !this.state.showShortDescriptionInListing
                                                })
                                            }}
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.account.form.edit.show_short_description_in_listing_description"
                                            defaultMessage="This will show product short description in listing and allow search in short description"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="showSKUInPricingTable">
                                    <FormattedMessage
                                        id="settings.account.form.edit.show_sku_in_pricing_table_label"
                                        defaultMessage="Show product SKU on the pricing table edition view"
                                    />
                                </label>
                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={"showSKUInPricingTable"}
                                            defaultChecked={this.state.showSKUInPricingTable}
                                            checked={this.state.showSKUInPricingTable}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    showSKUInPricingTable: !this.state.showSKUInPricingTable
                                                })
                                            }}
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.account.form.edit.show_sku_description"
                                            defaultMessage="This will show product SKUs in your pricing table view (not visible to customers)"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="showShortDescriptionInListing">
                                    <FormattedMessage
                                        id="settings.account.form.edit.auto_apply_credit_memo_on_new_invoice_label"
                                        defaultMessage="Auto apply available credit memo on new invoices"
                                    />
                                </label>
                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={"showShortDescriptionInListing"}
                                            defaultChecked={this.state.autoApplyAvailableCreditMemo}
                                            checked={this.state.autoApplyAvailableCreditMemo}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    autoApplyAvailableCreditMemo: !this.state.autoApplyAvailableCreditMemo
                                                })
                                            }}
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.account.form.edit.auto_apply_credit_memo_on_new_invoice_description"
                                            defaultMessage="This will automatically pay new invoices with available credit memo once created"
                                        />
                                    </small>
                                </div>
                            </div>

                            {supportedFeatures.map(f => {
                                return (
                                    <div className="form-group row" key={f.key}>
                                        <label className="col-2 col-form-label text-align-right" htmlFor={f.key}>
                                            {f.label}
                                        </label>
                                        <div className="col-10 pt-1">
                                            <Toggle
                                                id={f.key}
                                                defaultChecked={this.state.account.isFeatureEnabled(f.key)}
                                                icons={false}
                                                onChange={this.handleFeatureChange(f.key)}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                            {AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBranding) ? (
                                <div className="form-group row">
                                    <label className="col-2 col-form-label text-align-right" htmlFor="hideBranding">
                                        <FormattedMessage
                                            id="settings.account.form.edit.hide_branding"
                                            defaultMessage="Hide Branding"
                                        />
                                    </label>
                                    <div className="col-10">
                                        <div className="input-group mb-3">
                                            <Toggle
                                                id={"hideBranding"}
                                                checked={this.state.hideBranding}
                                                icons={false}
                                                onChange={() => {
                                                    this.setState({
                                                        hideBranding: !this.state.hideBranding
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="isTaxInclusive">
                                    <FormattedMessage
                                        id="settings.account.form.edit.is_tax_inclusive"
                                        defaultMessage="Tax Inclusive"
                                    />
                                </label>
                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={"isTaxInclusive"}
                                            defaultChecked={this.state.isTaxInclusive}
                                            checked={this.state.isTaxInclusive}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    isTaxInclusive: !this.state.isTaxInclusive
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="showPriceWarning">
                                    <FormattedMessage
                                        id="settings.account.form.edit.show_price_warning"
                                        defaultMessage="Show Price Warning"
                                    />
                                </label>
                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={"showPriceWarning"}
                                            defaultChecked={this.state.showPriceWarning}
                                            checked={this.state.showPriceWarning}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({
                                                    showPriceWarning: !this.state.showPriceWarning
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 ui-module">
                            <div className="row">
                                {this.state.isSubmitting ?
                                    <div className="col-12 text-align-center">
                                        <LoadingSpinner />
                                    </div> : <div className="col-6 text-align-right">
                                        <Link to="/settings" className="btn btn-light">
                                            <FormattedMessage id="settings.account.form.edit.cancel_btn" defaultMessage="Cancel" />
                                        </Link>
                                        &nbsp; &nbsp;
                                        <input
                                            type="submit"
                                            value={this.props.intl.formatMessage(messages["save_btn"])}
                                            className="btn btn-primary"
                                        /></div>}
                            </div>
                        </div>
                    </div>
                </form >
            </div >
        )
    }
}

export default injectIntl(AccountDetailsEditForm)



// WEBPACK FOOTER //
// ./src/settings/account/detailsEditForm.component.jsx